import React from 'react';

type Props = {
    avgCompletionDays: number;
    newTodayCount: number;
    inProgressCount: number;
};

const largeMetricCard: React.CSSProperties = {
    background: '#F5F5F5',
    borderRadius: 28,
    padding: '24px 20px',
    width: 300,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
};
const smallMetricCard: React.CSSProperties = {
    background: '#F5F5F5',
    borderRadius: 16,
    padding: '24px 20px',
    width: 180,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
};
const headerRow: React.CSSProperties = { display: 'flex', alignItems: 'baseline', gap: 8 };
const numBig: React.CSSProperties = { fontSize: '48px', lineHeight: '52px', fontFamily: 'CathaySansMd',fontWeight: 500 };
const unit: React.CSSProperties = { fontSize: '32px', lineHeight: '52px', fontFamily: 'CathaySansMd',fontWeight: 500 };
const desc: React.CSSProperties = { fontSize: '16px', lineHeight: '20px', color: '#000', fontFamily: 'CathaySansRg',fontWeight: 400 };

export default function KpiSummary({ avgCompletionDays, newTodayCount, inProgressCount }: Props) {
    return (
        <div style={{ display: 'flex', gap: 24, marginBottom: 24 }}>
            <div style={largeMetricCard}>
                <div style={headerRow}>
                    <div style={numBig}>{avgCompletionDays}</div>
                    <div style={unit}>days</div>
                </div>
                <div style={desc}>Average case completion time</div>
            </div>

            <div style={smallMetricCard}>
                <div style={numBig}>{newTodayCount}</div>
                <div style={{ ...desc, color: '#1A1A1A' }}>New in today</div>
            </div>

            <div style={smallMetricCard}>
                <div style={numBig}>{inProgressCount}</div>
                <div style={{ ...desc, color: '#1A1A1A' }}>In progress</div>
            </div>
        </div>
    );
}
